import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  date = new Date().getFullYear()
  tinyUrl= 'https://cosmosgranite.nyc3.digitaloceanspaces.com/cosmossurfaces/images';
  tinyUrl2= 'https://cosmosgranite.nyc3.cdn.digitaloceanspaces.com/igmcorp/assets/images';
  constructor() { }

  ngOnInit(): void {
  }

}
